import moment from 'moment';
import * as api from '../epics/api';

export const LOAD_MONTHLY_BOOKINGS = 'LOAD_MONTHLY_BOOKINGS';
export const LOAD_WEEKLY_BOOKINGS = 'LOAD_WEEKLY_BOOKINGS';
export const RESET_CALENDAR_BOOKINGS = 'RESET_CALENDAR_BOOKINGS';
export const LOADING_CALENDAR = 'LOADING_CALENDAR';

export function fetchCalendarEvents(query, view) {
    return dispatch => {
        if (view === 'month') {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            dispatch(fetchMonthlyCounters(query));
        } else {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            dispatch(getWeekJobsFromApi(query));
        }
    };
}

export function fetchMonthlyCounters(query) {
    return dispatch => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        dispatch(calendarLoading(true));
        api.getBookingCounters(query)
            .then(response => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                const bookingCounters = setUpCountersForMonthlyView(
                    response.data.content,
                );
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(loadMonthlyCalendar(bookingCounters));
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(calendarLoading(false));
            })
            .catch(() => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                dispatch(calendarLoading(false));
            });
    };
}

export function calendarLoading(boolean) {
    return {
        type: LOADING_CALENDAR,
        payload: boolean,
    };
}

export function loadMonthlyCalendar(data) {
    return {
        type: LOAD_MONTHLY_BOOKINGS,
        payload: data,
    };
}
export function loadWeeklyCalendar(data) {
    return {
        type: LOAD_WEEKLY_BOOKINGS,
        payload: data,
    };
}

export function resetCalendar() {
    return {
        type: RESET_CALENDAR_BOOKINGS,
        payload: [],
    };
}

export function setUpCountersForMonthlyView(bookingCounters) {
    // Flatterns Booking counter for monthly view
    const flattenCounters = [];
    bookingCounters.forEach(b => {
        const dates = { start: moment(b.date), end: moment(b.date) };
        if (b.completed_bookings > 0) {
            flattenCounters.push({
                ...dates,
                title: `${b.completed_bookings} Completed`,
                status: 'CP',
            });
        }
        if (b.confirmed_bookings > 0) {
            flattenCounters.push({
                ...dates,
                title: `${b.confirmed_bookings} Confirmed`,
                status: 'CF',
            });
        }
        if (b.open_bookings > 0) {
            flattenCounters.push({
                ...dates,
                title: `${b.open_bookings} Open`,
                status: 'OP',
            });
        }
    });
    return flattenCounters;
}

export function getWeekJobsFromApi(query) {
    return dispatch => {
        dispatch(calendarLoading(true));
        let jobsContent = [];
        const getNextJobContent = url => {
            api.executeHttpRequest(url, 'get', {}, false)
                .then(response => {
                    jobsContent = jobsContent.concat(
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        setUpJobsForWeeklyView(response.data.content),
                    );
                    if (response.data.meta.next) {
                        getNextJobContent(response.data.meta.next);
                    } else {
                        dispatch(loadWeeklyCalendar(jobsContent));
                        dispatch(calendarLoading(false));
                    }
                })
                .catch(() => {
                    dispatch(calendarLoading(false));
                });
        };

        api.fetchShifts(query)
            .then(response => {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                const jobs = setUpJobsForWeeklyView(response.data.content);
                jobsContent = jobsContent.concat(jobs);

                if (response.data.meta.next) {
                    getNextJobContent(response.data.meta.next);
                } else {
                    dispatch(loadWeeklyCalendar(jobsContent));
                    dispatch(calendarLoading(false));
                }
            })
            .catch(() => {
                dispatch(calendarLoading(false));
            });
    };
}

export function setUpJobsForWeeklyView(jobs) {
    const jobEvents = [];
    jobs.forEach(job => {
        jobEvents.push({
            title: `${job.reference_number}`,
            start: moment(job.start_datetime).toDate(),
            end: moment(job.end_datetime).toDate(),
            ...job,
        });
    });
    return jobEvents;
}
